/* eslint-disable react-hooks/exhaustive-deps */
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod, selectStandard } from 'store/redux-store/placement-mods/selectors';
import { makeStyles } from 'tss-react/mui';
import { dataSorting, findKeyBaseOnValue, formatTypeAheadOptions } from '../../ModificationsUtils';

const useStyles = makeStyles()(() => ({
  errorCls: {
    '& .MuiSelect-select': {
      borderBottom: '2px solid red',
    },
  },
  errorLable: {
    color: '#d32f2f',
  },
}));

interface ApprovalMethodProps {
  readOnly?: boolean;
}

export const ApprovalMethod = ({ readOnly }: ApprovalMethodProps) => {
  const { classes } = useStyles();
  const { control, formState: { errors }, getValues, setValue, setError, clearErrors, register } = useFormContext();
  const { t } = useTranslation();
  const approvalMethod = 'approvalMethod';
  const payer: string = useWatch({ name: 'payer' });
  register('approvalTypeId');
  const approvalMethodVal: string = useWatch({ name: 'approvalMethod' });
  const isModEdit = useSelector(selectIsEditMod);
  const standard = useSelector(selectStandard);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const [isFieldRequired, setFieldRequired] = useState<boolean>(false);
  const [bonusApprovedMethodOptions, setBonusApprovedMethodOptions] = useState([]);

  const getApprovalMethodDropDown = async () => {
    const options = await getSearchFilterOptions('approvalType');

    if (options?.length > 0) {
      const newOptions = formatTypeAheadOptions(options);
      setBonusApprovedMethodOptions(newOptions);

      if (payer === 'Client') {
        setFieldRequired(true);
        setError(approvalMethod, { type: 'Required' });
      } else {
        setFieldRequired(false);
        clearErrors(approvalMethod);
      }
      if (approvalMethodVal) {
        clearErrors(approvalMethod);
        const selectedOption = findKeyBaseOnValue(newOptions, approvalMethodVal);
        setValue('approvalTypeId', selectedOption?.id);
      }
    }
  };

  const getApprovalMethodId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(bonusApprovedMethodOptions, value);
    return selectedOption?.id;
  };

  const handleChange = (value?: string) => {
    setValue(approvalMethod, value);
    setValue('approvalTypeId', getApprovalMethodId(value));
    setValue('approvalDate', new Date());
    if (value) {
      clearErrors(approvalMethod);
    }
  };

  useEffect(() => {
    getApprovalMethodDropDown();
  }, [payer, isFieldRequired]);

  return (
    <Controller
      control={control}
      name={approvalMethod}
      rules={{
        required: isFieldRequired,
      }}
      render={({field: { onChange, value, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          customClass={isFieldRequired && !value ? classes.errorCls : ''}
          labelClass={isFieldRequired && !value ? classes.errorLable : ''}
          name={approvalMethod}
          require={isFieldRequired}
          label={`${t('placement.placementMods.approvalMethod')} ${isFieldRequired ? '*' : ''}`}
          standard={true}
          options={dataSorting(bonusApprovedMethodOptions) ?? []}
          handleChange={e => {
            const isReadOnlyField = readOnly !== undefined ? readOnly : (standard ? true : !isModEdit);
            if (!isReadOnlyField && e.target.value?.length > 0) {
              onChange(e.target.value);
              handleChange(e.target.value);
            }
          }}
          {...rest}
          readOnly={readOnly !== undefined ? readOnly : (standard ? true : !isModEdit)}
          isError={!!errors?.approvalMethod}
          helperText={
            !isNullOrUndefined(errors?.approvalMethod) ? (
              <span style={{ color: '#d32f2f' }}>{'Required'}</span>
            ) : undefined
          }
          disabled={isSaveModApiCalling || (readOnly !== undefined ? readOnly : (standard ? true : !isModEdit))}
          inputValue={getValues(approvalMethod) ?? ''}
        ></FormInputDropdown>
      )}
    />
  );
};
